import React, { useState, ReactChild } from "react";
import { IOneImage } from "./Common";
import LazyLoadColumn from "./LazyLoadColumn";
import { GalleryCheck } from "./GalleryCheck";
import useGalleryCheck from "./useGalleryCheck";
import classNames from "classnames";
import StatusTag from '../Tag/StatusTag';
import { IGalleryStatus } from '../../global.d';

interface IColumn1 extends IOneImage {
  afterChild?: ReactChild;
}

const Column1 = (props: IColumn1) => {
  const { checkShow, index, disabled } = useGalleryCheck(props);
  const [height, setHeight] = useState(0);
  const onLoad = function (e: React.UIEvent<HTMLImageElement>) {
    e.persist();
    const { currentTarget } = e;
    const { height } = currentTarget;
    // 因为这里有300ms延时之后的动画，所以必须等300ms之后获取到的数据才是正确的
    setTimeout(() => {
      const rect = currentTarget.getClientRects();
      if (rect && rect[0]) {
        const accurateHeight = rect[0].height; // 这个高度精度比外面的height搞
        setHeight(accurateHeight);
      } else {
        setHeight(height);
      }
    }, 300);
  };
  return (
    <div className="column column1" onClick={props.onClick}>
      <LazyLoadColumn>
        <div
          className={classNames("img-wrapper", { disabled })}
          data-id={props.id}
        >
          <img
            src={props.src}
            className={"img"}
            alt=""
            onLoad={onLoad}
            data-index={
              props && typeof props.index != 'undefined'
                ? props.index * 1 + 1
                : 0
            }
          />
          {checkShow ? <GalleryCheck index={index} /> : null}
          {props.isPayed ? <StatusTag
            status={IGalleryStatus.payed}
            className={'status payed-status'}
            fontSize={12}
          /> : null}
        </div>
      </LazyLoadColumn>
      {props.afterChild}
    </div>
  );
};

export default Column1;
